<template>
  <section class="py-5 h-100 d-flex justify-content-center">
    <v-card class="w-75 m-auto border rounded">
      <v-card-text class="p-4">
        <v-row>
          <v-col cols="12" sm="12" lg="6" class="border-right">
            <h2 :class="returnState()">QRate</h2>
            <br />
            <img
              alt="QRate"
              class="logo_img_lg w-100 h-75"
              src="../../assets/mobile_payments.png"
              style="max-height: 75% !important"
            />
          </v-col>

          <v-col cols="12" sm="12" lg="6" class="pb-2">
            <div class="w-100 m-auto p-5">
              <h2 class="text-center text-primary-color font-weight-bold">
                {{ $t("loginScreen.userLogin") }}
              </h2>
              <br />

              <form class="mb-4" autocomplete="off">
                <label class="text-midgray-color">{{
                  $t("loginScreen.loginUsingEmailPassword")
                }}</label>
                <v-text-field
                  v-model="user_details.email"
                  :label="$t('emailID')"
                  :error-messages="emailErrors"
                  clearable
                  @input="$v.user_details.email.$touch()"
                  @blur="$v.user_details.email.$touch()"
                  :class="{ 'is-invalid': $v.user_details.email.$error }"
                  append-icon="mdi-account-outline"
                  autocomplete="off"
                  :persistent-hint="false"
                ></v-text-field>

                <v-text-field
                  v-model="user_details.password"
                  :append-icon="
                    isVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                  "
                  @click:append="() => (isVisible = !isVisible)"
                  type="text"
                  :label="$t('password')"
                  ref="customPasswordField"
                  @focus="onFocus"
                  :error-messages="passwordErrors"
                  clearable
                  @input="$v.user_details.password.$touch()"
                  @blur="$v.user_details.password.$touch(), onBlur"
                  :class="{ 'is-invalid': $v.user_details.password.$error }"
                  @keydown="enterKeyPressed"
                  autocomplete="off"
                  :persistent-hint="false"
                ></v-text-field>

                <v-btn
                  depressed
                  block
                  color="primary"
                  @click="onClickLogin(false)"
                  class="mt-3 text-capitalize"
                  >{{ $t("loginScreen.signin") }}</v-btn
                >
              </form>
            </div>
          </v-col>
        </v-row>
        <v-dialog
          persistent
          v-model="forcelogoutDialog.is_dialogopen"
          width="500"
        >
          <v-card>
            <v-system-bar color="secondary" dark>
              <span class="font-weight-bold">{{
                forcelogoutDialog.title
              }}</span>
              <v-spacer></v-spacer>
            </v-system-bar>
            <v-card-text class="h5 py-3">
              <span class="font-weight-normal">{{
                forcelogoutDialog.message
              }}</span>

              <v-select
                v-if="is_under_multiple_partners"
                dense
                outlined
                :items="sending_partners"
                v-model="selected_sending_partner"
                class="rounded mt-4"
                placeholder="Channel Partner Country"
              >
              </v-select>
            </v-card-text>
            <v-divider class="mb-0"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="forcelogoutDialog.is_dialogopen = false"
                ><v-icon>mdi-close</v-icon>Cancel</v-btn
              >
              <v-btn
                small
                depressed
                color="primary"
                @click="
                  is_under_multiple_partners
                    ? onClickLogin(true)
                    : ForceLogout()
                "
              >
                <v-icon>mdi-check</v-icon>Proceed
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
    <loading
      :active="loader"
      :is-full-page="fullPage"
      :opacity="0.9"
      color="#ff6b00"
      :height="height"
      :width="width"
    />
  </section>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import userService from "@/services/UserService/userService.js";
import commonService from "@/services/CommonService/commonService.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "Login",
  mounted() {
    this.onBlur();
    sessionStorage.clear();
  },
  components: {
    Loading,
  },
  data() {
    return {
      isVisible: false,
      user_details: {
        email: this.$route.params.emailId || "",
        password: "",
      },
      loader: false,
      forcelogoutDialog: {
        title: "",
        is_dialogopen: false,
        message: "",
      },
      is_under_multiple_partners: false,
      selected_sending_partner: "",
      sending_partners: [],
      languageSelected: "en-us",
      dismissCountDown: 20,
      showDismissibleAlert: false,
      language_options: [
        {
          text: "English",
          value: "en-us",
        },
        {
          text: "Chinese",
          value: "zh-cn",
        },
      ],
      fullPage: true,
      height: 100,
      width: 100,
    };
  },
  validations: {
    user_details: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.$refs.customPasswordField.$el.querySelector(
          "input",
        ).style.webkitTextSecurity = "";
      } else {
        this.$refs.customPasswordField.$el.querySelector(
          "input",
        ).style.webkitTextSecurity = "disc";
      }
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.user_details.email.$dirty) return errors;
      !this.$v.user_details.email.required && errors.push("E-mail is required");
      !this.$v.user_details.email.email && errors.push("Must be valid e-mail");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.user_details.password.$dirty) return errors;
      !this.$v.user_details.password.required &&
        errors.push("Password is required");
      return errors;
    },
  },
  methods: {
    onBlur() {
      if (this.isVisible) {
        return;
      }
      this.$refs.customPasswordField.$el.querySelector(
        "input",
      ).style.webkitTextSecurity = "disc";
    },
    onFocus() {
      if (this.isVisible) {
        return;
      }
      this.$refs.customPasswordField.$el.querySelector(
        "input",
      ).style.webkitTextSecurity = "disc";
    },
    returnState() {
      return process.env.NODE_ENV === "dev"
        ? "text-white-color primary text-center"
        : "text-primary-color";
    },
    enterKeyPressed(event) {
      if (event.keyCode == 13) this.onClickLogin(false);
    },
    async ForceLogout() {
      setTimeout(() => this.$router.push({ name: "Two Factor Auth" }), 500);
      // this.loader = true;
      // try {
      //   const response = await userService.userForceLogoutByUsername({
      //     user_name: this.user_details.email,
      //     is_active: false,
      //   });
      //   if (response.data.status_code === 200) {
      //     this.onClickLogin(false);
      //     this.loader = false;
      //   } else {
      //     this.showAlertError(response.data.message);
      //     this.loader = false;
      //   }
      // } catch (error) {
      //   this.loader = false;
      //   console.error(error);
      // }
    },
    async getmainSenderpartner(user_name) {
      try {
        const response = await commonService.getmainSenderpartnerbyusername({
          user_name: user_name,
        });
        if (response.data.status_code === 200) {
          this.sending_partners = response.data.data.map((i) => {
            return { text: i.partner_name, value: i.partner_id };
          });
          if (this.sending_partners && this.sending_partners[0].text) {
            this.selected_sending_partner = this.sending_partners[0].value;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    async onClickLogin(params) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      const userDetails = {
        user_name: this.user_details.email,
        password: this.user_details.password,
      };
      params = this.selected_sending_partner
        ? {
            send_partner_id: this.selected_sending_partner,
          }
        : null;
      this.$store.commit("username", this.user_details.email);
      sessionStorage.setItem("username", this.user_details.email);
      this.$store.dispatch(
        "Authentication/saveUserEmail",
        this.user_details.email,
      );
      this.loader = true;
      try {
        const responseData = await userService.Login(userDetails, params);
        console.log("responseData", responseData);
        if (
          responseData &&
          responseData.data &&
          responseData.data.status_code == 200
        ) {
          this.loader = false;
          if (responseData.data.data[0].is_two_factor_auth) {
            sessionStorage.setItem(
              "__p_info",
              JSON.stringify(responseData.data.data[0].permissions_info),
            );
            setTimeout(
              () => this.$router.push({ name: "Two Factor Auth" }),
              500,
            );
          } else {
            if (responseData.data.data[0].user_type) {
              sessionStorage.setItem(
                "user_type",
                responseData.data.data[0].user_type,
              );
            }
            const isPermitted = true;
            const token = responseData.data.data[0]?.access_token;
            sessionStorage.setItem("isPermitted", isPermitted);
            sessionStorage.setItem("__ac_mn_tk", token);
            this.loader = false;
            this.$store.commit(
              "app/set_token",
              responseData.data.data[0]?.access_token,
            );
            this.loader = false;
            this.showAlertSuccess(responseData.data.message);
            console.log(
              "responseData.message",
              responseData.data.data[0].is_two_factor_auth,
            );
            sessionStorage.setItem(
              "is_evolet_user",
              responseData.data.data[0].is_evolet_user,
            );
            sessionStorage.setItem(
              "__ac_mn_tk",
              responseData.data.data[0].access_token,
            );
            sessionStorage.setItem(
              "__re_acc_tk",
              responseData.data.data[0].refresh_token,
            );
            const data = JSON.stringify(
              responseData.data.data[0].send_partner_data,
            );
            sessionStorage.setItem("send_partner_data", data);
            console.log("access", responseData.data.data[0].access_token);
            sessionStorage.setItem(
              "complete_registration",
              responseData.data.data[0].complete_registration,
            );
            sessionStorage.setItem(
              "__p_info",
              JSON.stringify(responseData.data.data[0].permissions_info),
            );

            this.$store.commit(
              "__ac_mn_tk",
              responseData.data.data[0].access_token,
            );
            this.$store.commit(
              "complete_registration",
              responseData.data.data[0].complete_registration,
            );
            setTimeout(() => this.$router.push({ name: "Home" }), 500);
          }
        } else {
          this.loader = false;
          if (
            responseData.data &&
            responseData.data.data[0] &&
            responseData.data.data[0].is_account_locked
          ) {
            this.forcelogoutDialog.title = "Force Session Out";
            this.forcelogoutDialog.is_dialogopen =
              responseData.data.data[0].is_account_locked;
            this.forcelogoutDialog.message = responseData.data.message;
            this.is_under_multiple_partners = false;
          } else if (
            responseData.data &&
            responseData.data.data[0] &&
            responseData.data.data[0].is_under_multiple_partners
          ) {
            this.getmainSenderpartner(this.user_details.email);
            this.forcelogoutDialog.title = "Select Partner";
            this.forcelogoutDialog.is_dialogopen =
              responseData.data.data[0].is_under_multiple_partners;
            this.forcelogoutDialog.message = responseData.data.message;
            this.is_under_multiple_partners =
              responseData.data.data[0].is_under_multiple_partners;
          } else {
            this.showAlertError(responseData.data.message);
          }
        }
      } catch (error) {
        console.error(error);
        this.showAlertError("Failed: Something went wrong");
        this.loader = false;
      }
    },
    languageChanged() {
      console.log("languageChanged: ", this.languageSelected);
      this.$i18n.locale = this.languageSelected;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.lead {
  font-weight: 400;
  color: $txt;
}
.logo_img {
  max-height: 50px;
}
.logo_img_lg {
  max-height: 100px;
}
.div-signup {
  color: $txt;
  cursor: pointer;
}
.login {
  height: 100%;
}
.invalid-feedback-email {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 12px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.invalid-feedback-password {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 12px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.language-selection {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button#input-type__BV_toggle_ {
  font-size: 10px;
}
.forgot-link {
  margin-top: 26px;
  line-height: 3rem;
}

.shadow_class {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  // width: %;
  background: #f8f9fa;
  border-radius: 7px;
}
</style>
